import React, { useCallback, useEffect } from "react";
import ReactDom from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { clearMessage } from "../../../../reducers/message";
import { logout } from "../../../../services/auth";
import Button from "../../../atoms/Button";
import Card from "../../../molecules/Card";
import CountdownTimer from "../../../molecules/CountdownTimer";
import PopupOverlay from "../../../organisms/Background/PopupOverlay";
import { ReactComponent as LogoutIcon } from "../../../../images/logout-icon.svg";
import "./index.scss";

export default function Logout({ onClose }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        if (!["/login", "/register"].includes(location.pathname)) {
            dispatch(clearMessage());
        }
    }, [dispatch, location]);

    const handleCancelClick = () => {
        onClose();
    };

    const handleLogOutClick = useCallback(() => {
        dispatch(logout())
            .then(() => {
                console.log("Logout successful");
                onClose();
            })
            .catch((error) => {
                console.error("Logout failed: ", error);
            });
    }, [dispatch, onClose]);

    const portalRoot = typeof document !== "undefined" ? document.getElementById("portal") : null;

    if (!portalRoot) {
        return null;
    }

    return ReactDom.createPortal(
        <PopupOverlay>
            <div className="logout-modal">
                <Card
                    className="logout-card"
                    title={t("logoutModal.title")}
                    body={(
                        <div className="logout-content">
                            <CountdownTimer
                                text={t("logoutModal.countdown")}
                                seconds={10}
                                onCountdownFinished={handleLogOutClick}
                            />
                        </div>
                    )}
                    footer={(
                        <div className="logout-actions">
                            <Button
                                variant="secondary"
                                size="large"
                                shape="pill"
                                className="logout-modal__action logout-modal__action--cancel"
                                onClick={handleCancelClick}
                            >
                                {t("common.cancel")}
                            </Button>
                            <Button
                                variant="danger"
                                size="large"
                                shape="pill"
                                className="logout-modal__action logout-modal__action--confirm"
                                onClick={handleLogOutClick}
                            >
                                {/* Decorative — the button text names the action. */}
                                <LogoutIcon
                                    className="logout-modal__action-icon"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                                {t("logoutModal.actions.confirm")}
                            </Button>
                        </div>
                    )}
                />
            </div>
        </PopupOverlay>,
        portalRoot
    );
}
